import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

async function getLegalDocument(apiClient: ApiClient, id: number) {
  return apiClient.GET('/op/v2/legal-document-versions/{id}', { params: { path: { id } } });
}

export function useLegalDocumentQuery(id: number) {
  const apiClient = useApiClient();
  const toast = useToast();
  const navigate = useNavigate();

  const query = useQuery<InferFetchData<typeof getLegalDocument>, ApiError>({
    queryKey: getKey(id),
    queryFn: () => throwOnError(getLegalDocument(apiClient, id)),
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [navigate, query.error, query.isError, toast]);

  return query;
}

export function getKey(id: number) {
  return ['LegalDocument', id] as const satisfies QueryKey;
}

useLegalDocumentQuery.getKey = getKey;
